// MapUtils.js
export const parsePopupFields = (fieldsString, layerTitle) => {
    if (!fieldsString || fieldsString === "test") return null;

    const fieldInfos = fieldsString.split(",").map((item) => {
        const parts = item.split("-").map((s) => s.trim());
        return {
            fieldName: parts[0],
            label: parts[1] || parts[0],
        };
    });

    return {
        title: layerTitle || "ინფორმაცია",
        content: [
            { type: "fields", fieldInfos: fieldInfos },
            {
                type: "text",
                text: "<a href='{URL}' target='_blank' style='color:#005e95; font-weight:bold;'>იხილეთ ვრცლად</a>",
            },
        ],
    };
};

export const configurePopups = (layers, configData) => {
    if (!layers) return;

    layers.forEach((sublayer) => {
        // ვეძებთ შესაბამის კონფიგურაციას ID-ით
        const cfg = configData.find(
            (c) => (c.layerid || c.LayerID || c.LayerId) == sublayer.id
        );

        if (cfg && (cfg.popupfields || cfg.PopupFields)) {
            const layerTitle = cfg.LayerName || cfg.layerName || sublayer.title;
            sublayer.popupTemplate = parsePopupFields(cfg.popupfields || cfg.PopupFields, layerTitle);
            sublayer.popupEnabled = true;
        }

        // თუ აქვს შიდა ფენები (Nested Layers), მათზეც იგივე გავაკეთოთ
        if (sublayer.sublayers && sublayer.sublayers.length > 0) {
            configurePopups(sublayer.sublayers, configData);
        }
    });
};

// MapUtils.js-ში დაამატეთ ეს ფუნქცია
export const createDynamicLayers = (configData, MapImageLayer) => {
    // 1. პირველ რიგში, მთლიანი კონფიგურაცია დავალაგოთ sort ველის მიხედვით
    const sortedConfig = [...configData].sort((a, b) =>
        (Number(a.sort) || 999) - (Number(b.sort) || 999)
    );

    // 2. ამოვიღოთ ვალიდური და უნიკალური URL-ები იმავე თანმიმდევრობით
    const validConfigs = sortedConfig.filter(c =>
        c.URL && typeof c.URL === "string" &&
        c.URL.toLowerCase().startsWith("http") &&
        c.URL.toLowerCase() !== "test"
    );

    const processedConfigs = validConfigs.map(c => {
        let correctedUrl = c.URL.trim();
        if (correctedUrl.includes("/FeatureServer")) {
            correctedUrl = correctedUrl.replace("/FeatureServer", "/MapServer");
        }
        return { ...c, correctedUrl };
    });

    // უნიკალური URL-ების მასივი, რომელიც ინარჩუნებს sort-ის პრიორიტეტს
    const uniqueUrls = [...new Set(processedConfigs.map(c => c.correctedUrl))];

    return uniqueUrls.map(url => {
        // ვიპოვოთ პირველივე ჩანაწერი ამ სერვისიდან, რომ სახელი სწორად დავარქვათ
        const firstMatch = processedConfigs.find(c => c.correctedUrl === url);

        const layer = new MapImageLayer({
            url: url,
            title: firstMatch?.LayerName || "სერვისი",
            visible: true
        });

        layer.when(() => {
            configurePopups(layer.sublayers, configData);
        });

        return layer;
    });
};

// MapUtils.js-ში დაამატეთ ეს ფუნქცია
// MapUtils.js

// MapUtils.js

// MapUtils.js-ში (მაგალითი)
// MapUtils.js-ში დაამატეთ ეს ფუნქცია
// MapUtils.js
export const createSearchSources = (configData, FeatureLayer) => {
    if (!configData) return [];

    return configData
        .filter(c => c && c.SearchFields && c.URL && c.URL !== "test")
        .map(c => {
            const layerId = c.LayerId || c.LayerID;
            const searchUrl = `${c.URL}/${layerId}`;
            const searchFields = c.SearchFields.split(",").map(f => f.trim());
            const displayField = c.SearchDisplayField || searchFields[0];
            const layerName = c.LayerName || "უცნობი ფენა";

            // ვქმნით ლეიერს ერთხელ
            const sourceLayer = new FeatureLayer({
                url: searchUrl,
                outFields: ["*"]
            });

            return {
                layer: sourceLayer,
                name: layerName,
                placeholder: `ძებნა: ${layerName}`,
                searchFields: searchFields,
                displayField: displayField,
                exactMatch: false,
                outFields: ["*"],
                suggestionsEnabled: true,
                suggestionsTemplate: `{${displayField}}`, // ეს უზრუნველყოფს ტექსტის გამოჩენას
                minSuggestCharacters: 2,
                popupEnabled: true,
                customData: {
                    layerId: layerId,
                    baseUrl: c.URL
                }
            };
        });
};
// MapUtils.js-ში დაამატე ეს ფუნქცია
// MapUtils.js
export const getLegendData = async (url, esriRequest) => {
    if (!url || url.includes("test")) return [];
    try {
        const response = await esriRequest(`${url}/legend`, {
            query: { f: "json" },
            responseType: "json"
        });
        return response.data.layers || [];
    } catch (error) {
        console.error("Legend request failed for: " + url);
        return [];
    }
};
// MapWidgets.js-ის ნაწილი
export const setupBasemapGallery = (view, ignored, reactiveUtils, t, { setIsLightLayer }) => {
    // კლასიკური ვიჯეტის ნაცვლად ვიყენებთ კომპონენტს
    const bgContainer = document.createElement("arcgis-basemap-gallery");
    bgContainer.view = view;

    // UI-ში დამატება (მაგალითად Expand-ში თუ გაქვთ)
    // view.ui.add(bgContainer, "top-right");

    // 🚀 .watch()-ის ნაცვლად reactiveUtils.watch()
    reactiveUtils.watch(
        () => view.map.basemap,
        (basemap) => {
            const isLight = basemap.title === "Gray" || basemap.title === "Light Gray Canvas";
            setIsLightLayer(isLight);
        }
    );
};